/**
 * Цветовая палитра глобальных продуктов
 */
const colors = {
    blue35: '#F6FAFFFF',
    blue50: '#F4F6FBFF',
    blue100: '#E5F2FFFF',
    blue200: '#CCE5FEFF',
    blue300: '#8AB9FFFF',
    blue450: '#245AFDFF',
    blue500: '#245AFDFF',
    blue600: '#0C3FD9FF',
    blue700: '#0836C2FF',
    blue800: '#0028A0FF',
    cyan100: '#E6FFFBFF',
    cyan200: '#B5F5ECFF',
    cyan500: '#36CFC9FF',
    cyan600: '#13C2C2FF',
    cyan700: '#08979CFF',
    cyan800: '#006D75FF',
    geekblue200: '#D6E4FFFF',
    geekblue500: '#597EF7FF',
    geekblue600: '#2F54EBFF',
    geekblue700: '#1D39C4FF',
    gold100: '#FFFBE6FF',
    gold200: '#FFF1B8FF',
    gold300: '#FFE58FFF',
    gold500: '#FFC53DFF',
    gold600: '#FAAD14FF',
    gold700: '#D48806FF',
    gold800: '#AD6800FF',
    gray0: '#FFFFFFFF',
    gray25: '#F6F8FFFF',
    gray50: '#EFF3FFFF',
    gray100: '#E9EDF9FF',
    gray150: '#E1E6F2FF',
    gray200: '#CFD5E5FF',
    gray400: '#8E9CBDFF',
    gray500: '#8E919AFF',
    gray650: '#6C717CFF',
    gray900: '#343A4AFF',
    green100: '#E0F7EAFF',
    green200: '#C1EFD4FF',
    green300: '#A3E8C0FF',
    green500: '#4DD083FF',
    green600: '#51AD77FF',
    green700: '#3D825AFF',
    purple100: '#F9F0FFFF',
    purple200: '#EFDBFFFF',
    purple500: '#9254DEFF',
    purple600: '#722ED1FF',
    purple700: '#531DABFF',
    red50: '#FEF5F7FF',
    red100: '#FEEDF0FF',
    red200: '#FCDBE1FF',
    red300: '#F9B7C3FF',
    red500: '#F36F87FF',
    red600: '#F04B69FF',
    red700: '#C03C54FF',
    red800: '#902D3FFF',
    volcano100: '#FFF2E8FF',
    volcano200: '#FFD8BFFF',
    volcano500: '#FF7A45FF',
    volcano600: '#FA541CFF',
    volcano700: '#D4380DFF',
    yellow500: '#FFEC3DFF',
    yellow600: '#FADB14FF',
    yellow700: '#D4B106FF',
    'blue35-transparent': '#007BFB0A',
    'blue50-transparent': '#007BFB0D',
    'blue100-transparent': '#007BFB1A',
    'blue150-transparent': '#007BFB26',
    'blue200-transparent': '#007BFB33',
    'blue400-transparent': '#007BFB66',
    'blue600-transparent': '#007BFB99',
    'blue800-transparent': '#007BFBCC',
    'cyan200-transparent': '#FFFFFF33',
    'geekblue200-transparent': '#2F54EB33',
    'gold50-transparent': '#FAAD140D',
    'gold100-transparent': '#FAAD141A',
    'gold150-transparent': '#FAAD1426',
    'gold200-transparent': '#FAAD1433',
    'gold400-transparent': '#FAAD1466',
    'gold600-transparent': '#FAAD1499',
    'gold800-transparent': '#FAAD14CC',
    'gray25-transparent': '#0C3FD908',
    'gray50-transparent': '#0C3FD90D',
    'gray100-transparent': '#0C3FD91A',
    'gray150-transparent': '#0C3FD926',
    'gray200-transparent': '#0C3FD933',
    'gray250-transparent': '#0C3FD940',
    'gray300-transparent': '#0C3FD94D',
    'gray350-transparent': '#0C3FD966',
    'gray400-transparent': '#0C3FD966',
    'gray450-transparent': '#0C3FD973',
    'gray500-transparent': '#0C3FD980',
    'gray550-transparent': '#0C3FD98C',
    'gray600-transparent': '#0C3FD999',
    'gray650-transparent': '#0C3FD9A6',
    'gray700-transparent': '#0C3FD9B3',
    'gray750-transparent': '#0C3FD9BF',
    'gray800-transparent': '#0C3FD9CC',
    'gray850-transparent': '#0C3FD9D9',
    'gray900-transparent': '#0C3FD9E6',
    'gray950-transparent': '#0C3FD9F2',
    'green50-transparent': '#4DD0830D',
    'green100-transparent': '#4DD0831A',
    'green150-transparent': '#4DD08326',
    'green200-transparent': '#4DD08333',
    'green400-transparent': '#4DD08366',
    'green600-transparent': '#4DD08399',
    'green800-transparent': '#4DD083CC',
    'purple200-transparent': '#722ED133',
    'red50-transparent': '#F04B690D',
    'red100-transparent': '#F04B691A',
    'red150-transparent': '#F04B6926',
    'red200-transparent': '#F04B6933',
    'red400-transparent': '#F04B6966',
    'red600-transparent': '#F04B6999',
    'red800-transparent': '#F04B69CC',
    'volcano200-transparent': '#FA541C33',
    'white25-transparent': '#FFFFFF08',
    'white50-transparent': '#FFFFFF0D',
    'white100-transparent': '#FFFFFF1A',
    'white150-transparent': '#FFFFFF26',
    'white200-transparent': '#FFFFFF33',
    'white250-transparent': '#FFFFFF40',
    'white300-transparent': '#FFFFFF4D',
    'white350-transparent': '#FFFFFF66',
    'white400-transparent': '#FFFFFF66',
    'white450-transparent': '#FFFFFF73',
    'white500-transparent': '#FFFFFF80',
    'white550-transparent': '#FFFFFF8C',
    'white600-transparent': '#FFFFFF99',
    'white650-transparent': '#FFFFFFA6',
    'white700-transparent': '#FFFFFFB3',
    'white750-transparent': '#FFFFFFBF',
    'white800-transparent': '#FFFFFFCC',
    'white850-transparent': '#FFFFFFD9',
    'white900-transparent': '#FFFFFFE6',
    'white950-transparent': '#FFFFFFF2',
    'yellow200-transparent': '#FFFFFF33',
};

export { colors };
//# sourceMappingURL=colors.js.map
